import { render, staticRenderFns } from "./magic-image-expand.vue?vue&type=template&id=2f3992bb&scoped=true&"
import script from "./magic-image-expand.vue?vue&type=script&lang=js&"
export * from "./magic-image-expand.vue?vue&type=script&lang=js&"
import style0 from "./magic-image-expand.vue?vue&type=style&index=0&id=2f3992bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3992bb",
  null
  
)

export default component.exports